"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NativeEventHandler_1 = require("./NativeEventHandler");

var root = require('./window-or-global');

exports.WEBVIEW_IS_READY_METHOD_NAME = 'WebViewIsReady';
exports.eventHandler = new NativeEventHandler_1.NativeEventHandler();
exports.on = exports.eventHandler.on.bind(exports.eventHandler);
exports.off = exports.eventHandler.off.bind(exports.eventHandler);
var store;
var nativeCallHandlers = {};

if (!root.callJavaScript) {
  root.callJavaScript = callJavaScript;
}

function initNativeCalls(_store, _nativeCallHandlers) {
  if (arguments.length === 1) {
    _nativeCallHandlers = _store;
    _store = null;
  }

  if (!isArray(_nativeCallHandlers) && !isDictionary(_nativeCallHandlers)) {
    throw new Error('Invalid nativeCallHandlers: must be array or object.');
  }

  store = _store;
  nativeCallHandlers = _nativeCallHandlers;
  notifyNativeWhenWebViewIsReady();
}

exports.initNativeCalls = initNativeCalls;

function callNative(action) {
  var stringifiedAction = JSON.stringify(action);
  console.log('Sending method to native: ' + action.methodName);
  exports.eventHandler.dispatchEvent('callNative', action);

  if (root.webkit) {
    root.webkit.messageHandlers.callNative.postMessage(stringifiedAction);
  } else if (root.Android) {
    root.Android.callNative(stringifiedAction);
  }
}

exports.callNative = callNative;

function useFromNative(name, fn) {
  if (isArray(nativeCallHandlers)) {
    throw new Error('initNativeCalls must be initialized with an object, not an array, when using useFromNative.');
  }

  nativeCallHandlers[name] = function handler(payload) {
    var normalized = clone(payload);
    delete normalized.methodName;
    return fn(normalized);
  };
}

exports.useFromNative = useFromNative;

function callJavaScript(message) {
  var payload;

  try {
    payload = isMessageAnObject(message) ? message : JSON.parse(message);
    unstringifyValues(payload);
    console.log('Received method from native: ' + payload.methodName);
    exports.eventHandler.dispatchEvent('callJavaScript', payload);
  } catch (e) {
    throw new Error('Invalid JSON received from a native call: ' + message);
  }

  if (isDictionary(nativeCallHandlers)) {
    if (nativeCallHandlers[payload.methodName]) {
      nativeCallHandlers[payload.methodName](payload, store);
    }

    if (nativeCallHandlers['*']) {
      nativeCallHandlers['*'](payload, store);
    }
  } else {
    nativeCallHandlers.forEach(function (fn) {
      fn(payload, store);
    });
  }
}

function notifyNativeWhenWebViewIsReady() {
  var RETRY_NUM_LIMIT = 10;
  var RETRY_TIME_INTERVAL = 250;

  var notifyNative = function notifyNative() {
    return callNative({
      methodName: exports.WEBVIEW_IS_READY_METHOD_NAME
    });
  };

  var attemptNum = 0;

  var storeIsInitialized = function storeIsInitialized() {
    return Boolean(root && root.callJavaScript && store && store.dispatch);
  };

  if (!storeIsInitialized()) {
    var interval_1 = setInterval(function () {
      if (++attemptNum > RETRY_NUM_LIMIT) {
        clearInterval(interval_1);
      }

      if (storeIsInitialized()) {
        clearInterval(interval_1);
        notifyNative();
      }
    }, RETRY_TIME_INTERVAL);
  } else {
    notifyNative();
  }
}

exports.notifyNativeWhenWebViewIsReady = notifyNativeWhenWebViewIsReady;

function unstringifyValues(obj) {
  Object.keys(obj).forEach(function (key) {
    try {
      obj[key] = JSON.parse(obj[key]);
    } catch (e) {}
  });
}

function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

function isDictionary(obj) {
  return obj !== null && typeof obj === 'object' && !Array.isArray(obj);
}

function isArray(obj) {
  return Array.isArray(obj);
}

function isMessageAnObject(message) {
  return typeof message === 'object';
}

exports.default = {
  initNativeCalls: initNativeCalls,
  callNative: callNative,
  useFromNative: useFromNative,
  notifyNativeWhenWebViewIsReady: notifyNativeWhenWebViewIsReady,
  WEBVIEW_IS_READY_METHOD_NAME: exports.WEBVIEW_IS_READY_METHOD_NAME,
  on: exports.on,
  off: exports.off,
  eventHandler: exports.eventHandler
};